// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-overlay {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .popup-content {
    background-color: transparent;
    border-radius: 8px;
    width: 100%;
  }
  
  .popup-content h2 {
    margin-top: 0;
  }
  
  .popup-content ul {
    list-style: none;
    padding: 0;
  }

  .popup-content ul div p{
    color: black;
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: bold;
  }
  
  .popup-content ul li {
    margin-bottom: 10px;
  }
  
  .popup-content ul li button {
    width: 100%;
    padding: 10px;
    border: none;
    background-color: rgb(13, 16, 48);
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
  }
  
  .popup-content ul li button:hover {
    background-color: #0056b3;
  }
  
  .close-button {
    display: block;
    width: 100%;
    padding: 10px;
    border: none;
    background-color: #dc3545;
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
  }
  
  .close-button:hover {
    background-color: #c82333;
  }

.popup-content .confirmation-popup{
  background-color: rgba(0, 0, 0, 0.877);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 8px 0 8px 8px;
  padding: 16px;
}

.popup-content .confirmation-popup .confirmation-popup-content{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 16px;
}

.popup-content .confirmation-popup .confirmation-popup-content p{
  font-size: 18px;
  font-weight: bold;
}

.popup-content .confirmation-popup .confirmation-popup-content button{
  padding: 16px;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  color: white;
}

.popup-content .confirmation-popup .confirmation-popup-content button.confirmBtn{
  background-color: forestgreen;

}

.popup-content .confirmation-popup .confirmation-popup-content button.declineBtn{
  background-color: rgb(255, 83, 83);
}`, "",{"version":3,"sources":["webpack://./src/components/AdminDashboard/TournamentActionsPopup.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,YAAY;IACZ,iCAAiC;IACjC,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;EACE,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,6BAA6B;;AAE/B;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".popup-overlay {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  .popup-content {\r\n    background-color: transparent;\r\n    border-radius: 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .popup-content h2 {\r\n    margin-top: 0;\r\n  }\r\n  \r\n  .popup-content ul {\r\n    list-style: none;\r\n    padding: 0;\r\n  }\r\n\r\n  .popup-content ul div p{\r\n    color: black;\r\n    margin-bottom: 8px;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  .popup-content ul li {\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .popup-content ul li button {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: none;\r\n    background-color: rgb(13, 16, 48);\r\n    color: #fff;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .popup-content ul li button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  .close-button {\r\n    display: block;\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: none;\r\n    background-color: #dc3545;\r\n    color: #fff;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  .close-button:hover {\r\n    background-color: #c82333;\r\n  }\r\n\r\n.popup-content .confirmation-popup{\r\n  background-color: rgba(0, 0, 0, 0.877);\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  border-radius: 8px 0 8px 8px;\r\n  padding: 16px;\r\n}\r\n\r\n.popup-content .confirmation-popup .confirmation-popup-content{\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  text-align: center;\r\n  gap: 16px;\r\n}\r\n\r\n.popup-content .confirmation-popup .confirmation-popup-content p{\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n}\r\n\r\n.popup-content .confirmation-popup .confirmation-popup-content button{\r\n  padding: 16px;\r\n  border-radius: 8px;\r\n  border: none;\r\n  font-size: 16px;\r\n  color: white;\r\n}\r\n\r\n.popup-content .confirmation-popup .confirmation-popup-content button.confirmBtn{\r\n  background-color: forestgreen;\r\n\r\n}\r\n\r\n.popup-content .confirmation-popup .confirmation-popup-content button.declineBtn{\r\n  background-color: rgb(255, 83, 83);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
